import { usePageEditorContext } from '../../contexts/page-editor.context'
import { useStyles } from './plaintext-block.style'

export const PlainTextBlock = function (props = {}) {
  if (!props.as) props.as = 'p'

  const { name, report: page = {}, placeholder, ...additionalProps } = props
  const classes = useStyles()

  const pageEditorContext = usePageEditorContext() || {}
  const currentEdit = pageEditorContext.currentEdit || {}
  const { [name]: currentEditValue } = currentEdit || {}

  let text = currentEditValue !== undefined ? currentEditValue : page[name]
  if (!text && placeholder) {
    text = <span className={classes.placeholder} data-qa={`edit-${name}-placeholder`}>{placeholder}</span>
  }

  // In edit mode, we may have a temporary title or description - in view mode we display the saved text on the report
  // TODO: We should move this logic into something editor specific instead of depending on page editor context from
  // this non-editor specific component.
  return (
    <props.as data-qa={`page-${name}`} {...additionalProps}>
      {text}
    </props.as>
  )
}
